import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { VersionDisplayComponent } from './components/version-display/version-display.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http'
import { LanguageService } from './shared/localization/language.service';
import { DriverManagementModule } from './shared/module/driver-mangement.module';


import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RequestOptionsProviderService } from './services/request-options-provider/request-options-provider.service';
import { DriverErrorHandlingService } from './services/request-options-provider/driver-error-handling/driver-error-handling.service';
import { DriverDetailsComponent } from './pages/driver-details/driver-details.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AccountDeleteModalComponent } from './components/account-delete-modal/account-delete-modal.component';
import { PhoneEnterComponent } from './pages/register/phone-enter/phone-enter.component';
import { PhoneConfirmComponent } from './pages/register/phone-confirm/phone-confirm.component';
import { ConfirmUpdateComponent } from './pages/driver-details/confirm-update/confirm-update.component';
import { EnterPhoneComponent } from './pages/login/forgotten-password/enter-phone/enter-phone.component';
import { VerifyCodeComponent } from './pages/login/forgotten-password/verify-code/verify-code.component';
import { ResetPasswordComponent } from './pages/login/forgotten-password/reset-password/reset-password.component';
import { ValidCodeModalComponent } from './components/valid-code-modal/valid-code-modal.component';
import { SaveSuccessModalComponent } from './components/save-success-modal/save-success-modal.component';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    VersionDisplayComponent,
    DriverDetailsComponent,
    AccountDeleteModalComponent,
    PhoneEnterComponent,
    PhoneConfirmComponent,
    ConfirmUpdateComponent,
    EnterPhoneComponent,
    VerifyCodeComponent,
    ResetPasswordComponent,
    ValidCodeModalComponent,
    SaveSuccessModalComponent,
    ErrorModalComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSpinnerModule,
    HttpClientModule,
    FontAwesomeModule,
    DriverManagementModule.forRoot([
      HttpClient,
      RequestOptionsProviderService,
      DriverErrorHandlingService,
    ]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: LanguageService.createTranslateLoader,
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    }),
  ],
  providers: [ NgbActiveModal ],
  bootstrap: [ AppComponent ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
